import { useMemo } from 'react';
import { bindActionCreators } from 'redux';
import { useSelector, useDispatch } from 'react-redux';
import {
  getList,
  exportByOrderList,
} from 'stores/invoiceManagement/actions/cetustekByOrderList';
import { getChannels } from 'stores/channels/actions/getChannels';
import useSearch from '../../hooks/useSearch';

export const baseParameters = {
  page: '1',
  limit: '25',
};

const useProps = () => {
  const { cetustekByOrderList } = useSelector(
    (state) => state.invoiceManagement,
  );
  const channels = useSelector((state) => state.channels);
  const dispatch = useDispatch();
  const { parameters, updateParams } = useSearch(baseParameters);
  const computedState = useMemo(
    () => ({
      parameters,
      ...channels,
      ...cetustekByOrderList,
    }),
    [parameters, channels, cetustekByOrderList],
  );

  const handlers = useMemo(
    () => ({
      updateParams,
      getList: bindActionCreators(getList, dispatch),
      getChannels: bindActionCreators(getChannels, dispatch),
      exportByOrderList: bindActionCreators(exportByOrderList, dispatch),
    }),
    [dispatch, updateParams],
  );

  return useMemo(
    () => ({ ...computedState, ...handlers }),
    [computedState, handlers],
  );
};

export default useProps;
